import "./style/RelifeContact.css";
import { NavLink, Link } from "react-router-dom";
import Animation from "../animation/Animation";
export default function RelifeContactNew() {
  return (
    <>
      {/* <Animation effect={"show"} elementAppear={"#relifeContact"}> */}
      <footer id="relifeContact">
        <div className="footer-brand">
          <h2 className="footer-logo">
            Introspecta<span>.</span>
          </h2>
          <p className="footer-desc">
            A premium audio-guided journey to understand your emotions and
            rediscover your purpose. Calm, professional, and entirely private.
          </p>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h6>EXPLORE</h6>
            <p>
              <a href={"/session"} className="link-contact">
                All Themes
              </a>
            </p>
            <p>
              <a href={"/pricing"} className="link-contact">
                Pricing
              </a>
            </p>
          </div>

          <div className="footer-col">
            <h6>COMPANY</h6>
            <p>
              <a href={"/about"} className="link-contact">
                About Introspecta
              </a>
            </p>
            <p>
              <a href={"/contact"} className="link-contact">
                Contact Support
              </a>
            </p>
          </div>

          <div className="footer-col">
            <h6>LEGAL</h6>
            <p>
              <a href={"/terms"} className="link-contact">
                Terms of Service
              </a>
            </p>
            <p>
              <a href={"/privacy"} className="link-contact">
                Privacy Policy
              </a>
            </p>
            <p>
              <a href={"/cookie-policy"} className="link-contact">
                Cookie Policy
              </a>
            </p>
            <p>
              <a href={"/disclaimer"} className="link-contact">
                Disclaimer
              </a>
            </p>
            <p>
              <a href={"/impressum"} className="link-contact">
                Impressum
              </a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-line" />
          <p className="footer-copy">
            Introspecta is a private space for guided self-reflection. It is not
            therapy, diagnosis, medical advice, or crisis support.
          </p>
          <p className="footer-copy">
            © 2026 Introspecta. All rights reserved.
          </p>
          <p className="footer-care">Made with care.</p>
        </div>
      </footer>
      {/* </Animation> */}
    </>
  );
}
